export const LOCAL_STORAGE_KEY = 'first-point';
export const SESSION_STORAGE_KEY = 'session-point';

export const phone = '+49 22 198 253 169';
export const email = 'vn@andersenlab.com';

export const meetupDate = '2025-02-18';
export const meetupStartTime = '13.00';
